import React from 'react';
import PropTypes from 'prop-types';
// import Link from 'components/Link';
import Slider from 'react-slick';
// import Image from 'components/Image';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import VsCard from '../../../components_v2/common/VsCard';
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/first
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/first
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/first
import makeRequest from 'utils/makeRequest';
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/first
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import s from './CardVisualStory.scss';
import { getCategoryForVisualStory } from '../../../utils/common';

class CardVisualStory extends React.Component {
  constructor() {
    super();
    this.state = {
      // isClientSide: false,
    };

    this.ref = React.createRef();
  }

  sendGA = data => {
    sendGaThroughProps({
      data,
    });
  };
  sendGAOnCLick = (item, index, typeofcard, vsSectionName) => {
    let data = {};
    const { clickGaAction, gaLabelConnector } = this.props;
    const connector = gaLabelConnector || '_';
    if (typeof item.gaData !== 'undefined' && item.gaData.gaAction) {
      data = item.gaData;
    } else if (clickGaAction) {
      data.gaAction = clickGaAction;
      data.gaLabel = `${index + 1}${connector}${item.wu}`;
    } else {
      data.gaAction = `${typeofcard}${vsSectionName}`;
      data.gaLabel = `${index + 1}${connector}${item.wu}`;
    }

    sendGaThroughProps({
      data,
    });
  };

  getUpdatedData = resetCallback => {
    if (this.state.nextUrl) {
      makeRequest.get(this.state.nextUrl, 'skipfeedengine').then(data => {
        if (data && data.data && data.data.items) {
          this.setState({
            items: [...this.state.items, ...data.data.items],
            nextUrl: data.data.nextPageData,
          });

          if (data.data.nextPageData && typeof resetCallback === 'function') {
            setTimeout(resetCallback, 0);
          }
        }
      });
    }
  };

  customOnError = e => {
    e.target.onerror = null;
    e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
  };

  render() {
    if (!this.props.sectionData || this.props.sectionData.length === 0) {
      return null;
    }
    const settings = {
      arrows: true,
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
    };
    return (
      <div className={`${s.sliderWrap}`}>
        <div className="slick_UI">
          <Slider {...settings} ref={this.ref}>
            {this.props.sectionData.length > 0 &&
              this.props.sectionData.map((item, index) => (
                <div className={s.vsCardWrap}>
                  <VsCard
                    title={item?.hl}
                    msid={
                      item?.imageid &&
                      typeof item.imageid === 'string' &&
                      item.imageid.includes('&')
                        ? item.imageid.split('&')[0]
                        : item?.imageid
                    }
                    thumbsize={item?.imagesize || item?.thumbsize}
                    wu={item?.wu}
                    // isWapView
                    isLarge={!this.props.disableIsLarge}
                    sectionName={`${
                      item.category
                        ? `${item.category}`
                        : getCategoryForVisualStory(item.wu)
                    }`}
                    index={item}
                    lazyloadImg={!this.props.ajaxCall}
                    isToiWidget={this.props.isToiWidget}
                    ga4Type={this.props?.ga4Type}
                    gaIndex={index + 1}
                  />
                </div>
              ))}
          </Slider>
        </div>
      </div>
    );
  }
}
CardVisualStory.contextType = UseIntersectionObeserver;
CardVisualStory.propTypes = {
  sectionData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string,
  }),
  cardType: PropTypes.string,
  ajaxCall: PropTypes.bool,
  gaData: PropTypes.shape({}),
  clickGaAction: PropTypes.string,
  wrapperClass: PropTypes.string,
  gaLabelConnector: PropTypes.string,
  isEtimesArticle: PropTypes.bool,
};
CardVisualStory.defaultProps = {
  sectionData: {},
  cardType: '',
  gaData: null,
  ajaxCall: false,
  clickGaAction: null,
  wrapperClass: undefined,
  gaLabelConnector: '',
  isEtimesArticle: false,
};

export default CardVisualStory;
